// extracted by mini-css-extract-plugin
export default {"heatmapWidgetWrapper":"HeatmapWidget_heatmapWidgetWrapper__E-PXD","wrapper":"HeatmapWidget_wrapper__+fOQm","icon":"HeatmapWidget_icon__HVkYQ","button":"HeatmapWidget_button__z13v0"};